module.exports = __webpack_public_path__ + "media/images/tmp/slide7-817a81965bac74602885c28b66ec5119.jpg";